module.exports = __webpack_public_path__ + "static/media/switch-logo.fcbcaab5.svg";